import { isDevelopmentEnv } from "@/shared/utils/environment-variables";

export type Callback<EventType extends unknown[]> = (...ev: EventType) => Promise<void> | void;

export class Event<EventType extends unknown[]> {
    private readonly _callbacks: Array<Callback<EventType>> = [];

    public constructor(protected readonly _name: string) {
        if (isDevelopmentEnv()) console.log(`Event('${this._name}')`);
    }

    public addHandler(cb: Callback<EventType>): () => void {
        this._callbacks.push(cb);
        return () => this.removeHandler(cb);
    }

    public removeHandler(cb: Callback<EventType>): void {
        const idx = this._callbacks.lastIndexOf(cb);
        if (idx >= 0) {
            this._callbacks.splice(idx, 1);
        }
    }

    public async raise(...ev: EventType): Promise<void> {
        if (isDevelopmentEnv()) console.debug("raise:", ...ev);
        for (const cb of this._callbacks) {
            await cb(...ev);
        }
    }
}
